// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1-X4t","requiredAsterisk":"Info_requiredAsterisk__nG0GK"};